import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PostStackState {
  postStackData: any;
  // ... other state properties
}

const initialState: PostStackState = {
  postStackData: {},
  // ... other initial state
};

const postStackSlice = createSlice({
  name: 'postStack',
  initialState,
  reducers: {
    setPostStackData: (state, action: PayloadAction<any>) => {
      state.postStackData = action.payload;
    },
    // ... other reducers
  }
});

export const { setPostStackData } = postStackSlice.actions;
export default postStackSlice.reducer; 